const BASE_URL = '/api'; 
const WINDY_API_KEY = "Tk5NaSFG2tDEHHSBdKkcoAOYpGBuRpHU";
const WINDY_URL = "https://api.windy.com/api/point-forecast/v2";

export const weatherApi = {
  getCurrentWeather: async (lat, lon) => {
    const response = await fetch(`${BASE_URL}/weather?lat=${lat}&lon=${lon}`);
    return response.json();
  },

  getForecast: async (lat, lon) => {
    const response = await fetch(`${BASE_URL}/forecast?lat=${lat}&lon=${lon}`);
    return response.json();
  },

  getRadarImage: async (timestamp) => {
    const response = await fetch(`${BASE_URL}/radar?timestamp=${timestamp}`);
    return response.json();
  },

  getWeatherType: async () => {
    const response = await fetch(`${BASE_URL}/weather/mid/type`);
    return response.json();
  },

  getWindyForecast: async (lat, lon) => {
    const response = await fetch(`${WINDY_URL}?lat=${lat}&lon=${lon}&key=${WINDY_API_KEY}`);
    return response.json();
  }
};
